export enum LOCATION {
    PHYSICAL = "physical",
    ONLINE = "online",
  }